import React, { useEffect, useState } from 'react';
export default function Complaints() { 
    return (
        <>Complaints - Inprogress</>
    );
}